import { create } from "zustand";

export const useAuthStore = create((set) => ({
  userData: null,
  hasBlog: false,
  isLoggedIn: false,
  mainBlogId: null,
  blogData: null,
  isPhysician: false,
  isVerified: true,
  setAuthData: (auth) =>
    set((state) => ({
      userData: auth.userData ?? state.userData,
      isLoggedIn: auth.isLoggedIn ?? state.isLoggedIn,
      hasBlog: auth.hasBlog ?? state.hasBlog,
      mainBlogId: auth.mainBlogId ?? state.mainBlogId,
      blogData: auth.blogData ?? state.blogData,
      isPhysician: auth.isPhysician ?? state.isPhysician,
    })),
  setIsVerified: (isVerified) => set(() => ({ isVerified: isVerified })),
}));
